import { useEffect, useState } from "react";

/** The phone range: where the header hides its desktop search slot for the icon button (header.module.css, 768px). */
export const MOBILE_QUERY = "(max-width: 767px)";

const read = () => typeof window.matchMedia === "function" && window.matchMedia(MOBILE_QUERY).matches;

/**
 * Whether the viewport is phone-sized, kept current as it changes. False where `matchMedia` does not exist.
 *
 * @returns {boolean}
 */
export const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(read);

  useEffect(() => {
    if (typeof window.matchMedia !== "function") return undefined;

    const query = window.matchMedia(MOBILE_QUERY);
    const update = () => setIsMobile(query.matches);
    update();
    query.addEventListener("change", update);
    return () => query.removeEventListener("change", update);
  }, []);

  return isMobile;
};
